import React, { useState } from 'react'
import AddResult from './AddResult'

function AddResultComponent({hostcupId, roundId}) {

    const [show, setShow] = useState(false)

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    return (
        <React.Fragment>
            <div className="card card-header" onClick={toggle}>
                <div>Legg til resultater <span className="float-right"><i className={`fas fa-chevron-${show ? "down" : "up"}`}></i></span></div>
            </div>
            {show && (
                <React.Fragment>
                    <h4>Trekning 1</h4>
                    <AddResult draw="1" homeTeam="A" awayTeam="B" hostcupId={hostcupId} roundId={roundId} kampNr="1" />
                    <AddResult draw="1" homeTeam="C" awayTeam="D" hostcupId={hostcupId} roundId={roundId} kampNr="2"  />
                    <AddResult draw="1" homeTeam="E" awayTeam="F" hostcupId={hostcupId} roundId={roundId} kampNr="3"  />
                    <AddResult draw="1" homeTeam="G" awayTeam="H" hostcupId={hostcupId} roundId={roundId} kampNr="4" />
                    <AddResult draw="1" homeTeam="A" awayTeam="D" hostcupId={hostcupId} roundId={roundId} kampNr="5" />
                    <AddResult draw="1" homeTeam="C" awayTeam="B" hostcupId={hostcupId} roundId={roundId} kampNr="6" />
                    <AddResult draw="1" homeTeam="E" awayTeam="H" hostcupId={hostcupId} roundId={roundId} kampNr="7" />
                    <AddResult draw="1" homeTeam="G" awayTeam="F" hostcupId={hostcupId} roundId={roundId} kampNr="8" />

                    <hr />
                    <h4>Trekning 2</h4>
                    <AddResult draw="2" homeTeam="A" awayTeam="B" hostcupId={hostcupId} roundId={roundId} kampNr="1" />
                    <AddResult draw="2" homeTeam="C" awayTeam="D" hostcupId={hostcupId} roundId={roundId} kampNr="2"  />
                    <AddResult draw="2" homeTeam="E" awayTeam="F" hostcupId={hostcupId} roundId={roundId} kampNr="3" />
                    <AddResult draw="2" homeTeam="G" awayTeam="H" hostcupId={hostcupId} roundId={roundId} kampNr="4" />
                    <AddResult draw="2" homeTeam="A" awayTeam="D" hostcupId={hostcupId} roundId={roundId} kampNr="5" />
                    <AddResult draw="2" homeTeam="C" awayTeam="B" hostcupId={hostcupId} roundId={roundId} kampNr="6" />
                    <AddResult draw="2" homeTeam="E" awayTeam="H" hostcupId={hostcupId} roundId={roundId} kampNr="7" />
                    <AddResult draw="2" homeTeam="G" awayTeam="F" hostcupId={hostcupId} roundId={roundId} kampNr="8" />

                    <hr />
                    <h4>Trekning 3</h4>
                    <AddResult draw="3" homeTeam="A" awayTeam="B" hostcupId={hostcupId} roundId={roundId} kampNr="1" />
                    <AddResult draw="3" homeTeam="C" awayTeam="D" hostcupId={hostcupId} roundId={roundId} kampNr="2" />
                    <AddResult draw="3" homeTeam="E" awayTeam="F" hostcupId={hostcupId} roundId={roundId} kampNr="3" />
                    <AddResult draw="3" homeTeam="G" awayTeam="H" hostcupId={hostcupId} roundId={roundId} kampNr="4" />
                    <AddResult draw="3" homeTeam="A" awayTeam="D" hostcupId={hostcupId} roundId={roundId} kampNr="5" />
                    <AddResult draw="3" homeTeam="C" awayTeam="B" hostcupId={hostcupId} roundId={roundId} kampNr="6" />
                    <AddResult draw="3" homeTeam="E" awayTeam="H" hostcupId={hostcupId} roundId={roundId} kampNr="7" />
                    <AddResult draw="3" homeTeam="G" awayTeam="F" hostcupId={hostcupId} roundId={roundId} kampNr="8" />
                </React.Fragment>
            )}

        </React.Fragment>
    )

}
export default AddResultComponent